import Index from "../../pages/ares/secondAnniversary/index";

const base = "secondAnniversary";

const routes = [{
        path: `/${base}/index`,
        name: `${base}-index`,
        component: Index,
    },
    {
        path: `/${base}/enter*`,
        name: `${base}-enter`,
        component: Index,
    },
];

export default routes;


// WEBPACK FOOTER //
// ./src/router/ares/secondAnniversary.js